import React, { useEffect, useContext, useState } from 'react'
import { add } from 'date-fns'
import { isToday } from 'utils'
import { useNavigate } from 'react-router-dom'

import PrimaryButton from 'components/primaryButton'

import { MovementsContext } from 'contexts/movements'
import { MeContext } from 'contexts/me'

import PageWrapper from 'components/PageWrapper'
import { FilterInputs, listboxOptions } from 'components/dateFilter'

const MobileActivityFilter = () => {
  const { dateRange, setDateRange, callActivities } =
    useContext(MovementsContext)
  const { me } = useContext(MeContext)
  const navigate = useNavigate()

  const [customPeriod, setCustomPeriod] = useState({
    startDate: new Date(dateRange.created_from),
    endDate: dateRange.created_until
      ? new Date(dateRange.created_until)
      : new Date(),
    key: 'selection'
  })
  const [selectedPeriod, setSelectedPeriod] = useState(listboxOptions[0])
  const [isCalendarVisible, setCalendarVisible] = useState(false)

  useEffect(() => {
    if (isCalendarVisible) {
      const { startDate, endDate } = customPeriod

      const created_from = startDate
      const created_until = isToday(new Date(endDate))
        ? null
        : add(endDate, { days: 1 })

      setDateRange({ created_from, created_until })
    }
  }, [customPeriod, isCalendarVisible])

  useEffect(() => {
    setDateRange({
      created_from: add(new Date(), { weeks: -1 }),
      created_until: null
    })
  }, [])

  return (
    <PageWrapper
      noTabBar
      viewSelected='/movimientos'
      title='Filtrar por fecha'
      forcedBackNavigation={() => navigate(-1)}
    >
      <section className='min-h-[85vh] flex flex-col justify-between'>
        <FilterInputs
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
          customPeriod={customPeriod}
          setDateRange={setDateRange}
          setCalendarVisible={setCalendarVisible}
          isCalendarVisible={isCalendarVisible}
          setCustomPeriod={setCustomPeriod}
        />
        <PrimaryButton
          buttonText='Filtrar'
          primaryButtonFunction={() => {
            callActivities({
              walletUUID: me?.bank?.internal_account[0]?.wallet_account
            })
            navigate(-1)
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default MobileActivityFilter
